import styled, { css } from 'styled-components';
import { BaSeTheme } from '../../theme';
import { numberWithUnit } from '../../utils/string-utils';

export const initialPosition = 'initial';
export const defaultBorderRadius = '50%';
export const paddingWithIcon = '2px';
export const paddingWithValue = '2px 6px';
export const paddingWithoutAnything = '8px';

interface BadgeStyle {
  right: string | number;
  top: string | number;
  left: string | number;
  bottom: string | number;
  backgroundColor: string;
  border: string;
  color: string;
  borderRadius: string | number;
  padding: string | number;
  width?: string | number;
  height?: string | number;
}

export const BadgeContainer = styled.div.attrs({
  className: 'BaSe--badge-container',
})`
  &.BaSe--badge-container {
    display: flex;
    width: fit-content;
  }
`;

export const BadgeContent = styled.div.attrs({
  className: 'BaSe--badge-content',
})`
  &.BaSe--badge-content {
    font-family: ${BaSeTheme.typography.fontFamily};
  }
`;

export const Badge = styled.div.attrs({
  className: 'BaSe--badge',
})<BadgeStyle>`
  &.BaSe--badge {
    box-sizing: border-box;
    position: relative;
    top: ${({ top }) => numberWithUnit(top)};
    bottom: ${({ bottom }) => numberWithUnit(bottom)};
    left: ${({ left }) => numberWithUnit(left)};
    right: ${({ right }) => numberWithUnit(right)};
    padding: ${({ padding }) => padding};
    border-radius: ${({ borderRadius }) => numberWithUnit(borderRadius)};
    border: 2px solid ${({ border }) => border};
    background-color: ${({ backgroundColor }) => backgroundColor};

    ${({ width }) => css`
      min-width: ${numberWithUnit(width ?? '1em')};
      width: ${numberWithUnit(width)};
    `}
    ${({ height }) => css`
      min-height: ${numberWithUnit(height ?? '1em')};
      height: ${numberWithUnit(height)};
      ${BadgeContent} {
        font-size: calc(${numberWithUnit(height ?? '2em')} - 1em);
        line-height: calc(${numberWithUnit(height ?? '2em')} - 1em);
      }
    `}

    &, ${BadgeContent} {
      display: grid;
      place-items: center;
    }

    ${BadgeContent} {
      color: ${({ color }) => color};
    }
  }
`;
